
// Config object to be passed to Msal on creation

const NEXTJS_APP_CLIENT_ID='36a1269e-cd84-4679-93e1-794bfad99f7e'
const NEXTJS_APP_AUTHORITY='https://carbonpumpcustomers.ciamlogin.com/'

export const msalConfig = {
    auth: {
        clientId: NEXTJS_APP_CLIENT_ID,
        authority: NEXTJS_APP_AUTHORITY,
        redirectUri: "/",
        postLogoutRedirectUri: "/"
    },
    cache: {
        cacheLocation: 'localStorage', // Change this to 'sessionStorage' if you prefer
        storeAuthStateInCookie: true, // Set this to true to use cookies
    },
    system: {
        allowNativeBroker: false, // Disables WAM Broker
    }
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest = {
    scopes: ["User.Read"]
};

// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};
